import { getConfigFromElement } from "web-shared/lib";

export const config = getConfigFromElement('app_config') as api.SiteConfig;
